
import React from 'react';
import styles from './CustomTimePicker.module.scss';

function StaticTime(props) {
  const timList=[
    {
        from:'08:00',
        to:'12:00'
    },
    {
        from:'12:00',
        to:'14:00'
    },
    {
        from:'14:00',
        to:'18:00'
    },
    {
        from:'18:00',
        to:'22:00'
    },
    {
        from:'22:00',
        to:'23:59'
    },
    {
        from:'00:00',
        to:'08:00'
    }
  ]
  return (
     <div className={styles.staticTime}>
            {timList.map((el, ind)=>{
               return <div onClick={()=>props.onChange(el)} key={ind} className={styles.staticTimeItem}>{el.from} - {el.to}</div>
            })}
      </div>
  );
}
export default StaticTime;